/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Źródło zapytania. Brak wartości oznacza nieustalone źródło starszego procesu lub klienta API.
 */

export const InquirySourceDto = {
    Form: 'FORM',
    Facebook: 'FACEBOOK',
    Mailbox: 'MAILBOX',
    Active: 'ACTIVE',
    Reactive: 'REACTIVE',
    Other: 'OTHER',
} as const;

export type InquirySourceDto = typeof InquirySourceDto[keyof typeof InquirySourceDto];



